<template lang="pug">


header

  img(:src="header.logo")
  div.bm-header
    small(v-html="header.copy")
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "ConfiguratorHeader",
  computed: {
    ...mapGetters(["header", "errorMessage"]),
  },
  methods: {
    ...mapMutations(["setErrorMessage"]),
  },
};
</script>

<style lang="scss" scoped>
header {
  display: flex;
  gap: 1.25rem 2rem;
  margin: 0 0 0rem;
  flex-direction: column;
  @include mq(lg) {
  margin: 0 0 0rem;
    flex-direction: row;
  }
}
.bm-header {
  a {
    color: #004E7D;
  }
}

img {
  align-self: center;
  @include mq(lg) {
    flex: 0 1 250px;
    min-width: 225px;
  }
}

div {
  position: relative;
  display: flex;
  @include mq(lg) {
    padding: 0.25rem 0;
    &::before {
      content: "";
      width: 1px;
      background: lighten($midGray, 10%);
      position: relative;
      left: -1.125rem;
      top: 0;
      bottom: 0;
    }
  }
  small::v-deep *:last-child {
    margin-bottom: 0;
  }
}
</style>